import { CommonStatusTag } from 'components/CommonStatusTag';

import { colors } from 'constants/colors';

import { TagState as TagStateEnum } from 'data/__generated__';

const getColorsFromType = (state: TagStateEnum) => {
    const { green, black, lightGrey } = colors;

    switch (state) {
        case TagStateEnum.Archived:
            return { backgroundColor: lightGrey, labelColor: black };
        case TagStateEnum.Regular:
            return { backgroundColor: green, labelColor: black };
    }
};

const TAG_STATE_LABELS: Record<TagStateEnum, string> = {
    [TagStateEnum.Archived]: 'Archivé',
    [TagStateEnum.Regular]: 'Actif',
};

export const TagState = ({ state }: { state: TagStateEnum }) => {
    const { backgroundColor, labelColor } = getColorsFromType(state);
    return (
        <CommonStatusTag backgroundColor={backgroundColor} labelColor={labelColor} label={TAG_STATE_LABELS[state]} />
    );
};
